export enum VirtualDataRoomFileProcessingState {
  NOT_PROCESSED = "NOT_PROCESSED",
  PROCESSING_AI_SUMMARY = "PROCESSING_AI_SUMMARY",
  PROCESSED = "PROCESSED",
  CANNOT_BE_ANALYZED = "CANNOT_BE_ANALYZED",
}
